module.exports = __webpack_public_path__ + "static/media/90506347-7LdjN.77e7d8ee.jpeg";